export interface Weapon {
  id: number;
  name: string;
  nameRu: string;
  weight: number;
  attack: number;
  activeDefense: number;
  passiveDefense: number;
  range: number;
  actionPoints: number;
  cellsOccupied: number;
  cost?: number; // Стоимость в золоте для кузницы
  costMetal?: number; // Стоимость в металле
  costWood?: number; // Стоимость в дереве
  costLeather?: number; // Стоимость в коже
  rankRequired?: number; // Требуемый ранг (для оружия орков: 0 - молодой, 1 - боец, 2 - ветеран)
}

export const WEAPONS: Weapon[] = [
  {
    id: 0,
    name: 'club',
    nameRu: 'Дубина',
    weight: 4,
    attack: 3,
    activeDefense: 0,
    passiveDefense: 0,
    range: 1,
    actionPoints: 3,
    cellsOccupied: 1,
    cost: 10,
    costWood: 5 // Дерево для дубины
  },
  {
    id: 1,
    name: 'small_sword',
    nameRu: 'Меч малый',
    weight: 3,
    attack: 3,
    activeDefense: 0,
    passiveDefense: 0,
    range: 1,
    actionPoints: 3,
    cellsOccupied: 1,
    cost: 20,
    costMetal: 10,
    costLeather: 5 // Кожа для рукояти
  },
  {
    id: 2,
    name: 'large_sword',
    nameRu: 'Меч большой',
    weight: 5,
    attack: 5,
    activeDefense: 0,
    passiveDefense: 0,
    range: 2,
    actionPoints: 5,
    cellsOccupied: 2,
    cost: 40,
    costMetal: 25,
    costLeather: 10 // Больше кожи для большой рукояти
  },
  {
    id: 3,
    name: 'small_shield',
    nameRu: 'Щит малый',
    weight: 3,
    attack: 0,
    activeDefense: 3,
    passiveDefense: 1,
    range: 0,
    actionPoints: 3,
    cellsOccupied: 1,
    cost: 25,
    costMetal: 15,
    costWood: 5,
    costLeather: 5 // Кожа для ремней
  },
  {
    id: 4,
    name: 'large_shield',
    nameRu: 'Щит большой',
    weight: 4,
    attack: 0,
    activeDefense: 4,
    passiveDefense: 2,
    range: 0,
    actionPoints: 2,
    cellsOccupied: 1,
    cost: 50,
    costMetal: 30,
    costWood: 10,
    costLeather: 10 // Больше кожи для большого щита
  },
  {
    id: 5,
    name: 'small_bow',
    nameRu: 'Лук малый',
    weight: 2,
    attack: 2,
    activeDefense: 0,
    passiveDefense: 0,
    range: 3,
    actionPoints: 3,
    cellsOccupied: 2,
    cost: 15,
    costWood: 10,
    costLeather: 3 // Кожа для тетивы
  },
  {
    id: 6,
    name: 'large_bow',
    nameRu: 'Лук большой',
    weight: 5,
    attack: 4,
    activeDefense: 0,
    passiveDefense: 0,
    range: 5,
    actionPoints: 5,
    cellsOccupied: 2,
    cost: 35,
    costWood: 20,
    costLeather: 8 // Больше кожи для большого лука
  },
  {
    id: 7,
    name: 'wooden_shield',
    nameRu: 'Щит деревянный',
    weight: 3,
    attack: 0,
    activeDefense: 2,
    passiveDefense: 1,
    range: 0,
    actionPoints: 3,
    cellsOccupied: 1,
    cost: 10,
    costWood: 15 // Только дерево
  },
  {
    id: 8,
    name: 'leather_armor',
    nameRu: 'Кожаные доспехи',
    weight: 2,
    attack: 0,
    activeDefense: 0,
    passiveDefense: 1,
    range: 0,
    actionPoints: 0,
    cellsOccupied: 0,
    cost: 20,
    costLeather: 25 // Только кожа
  },
  {
    id: 9,
    name: 'metal_armor',
    nameRu: 'Металлические доспехи',
    weight: 3,
    attack: 0,
    activeDefense: 0,
    passiveDefense: 2,
    range: 0,
    actionPoints: 0,
    cellsOccupied: 0,
    cost: 40,
    costMetal: 40,
    costLeather: 10 // Кожа для подкладки
  },
  // Оружие орков (ID 10-19)
  // Ранг 0 (молодой орк): кинжал (10), костяной нагрудник (13)
  {
    id: 10,
    name: 'bone_dagger',
    nameRu: 'Костяной Кинжал',
    weight: 2,
    attack: 2,
    activeDefense: 0,
    passiveDefense: 0,
    range: 1,
    actionPoints: 2,
    cellsOccupied: 1,
    rankRequired: 0
  },
  {
    id: 13,
    name: 'bone_shield_orc',
    nameRu: 'Костяной Щит Орка',
    weight: 2,
    attack: 0,
    activeDefense: 2,
    passiveDefense: 1,
    range: 0,
    actionPoints: 2,
    cellsOccupied: 1,
    rankRequired: 0
  },
  // Ранг 1 (боец): ржавый топор (11), деревянный щит (14), кожа мутанта (18)
  {
    id: 11,
    name: 'rusty_axe',
    nameRu: 'Ржавый Топор',
    weight: 4,
    attack: 4,
    activeDefense: 0,
    passiveDefense: 0,
    range: 1,
    actionPoints: 4,
    cellsOccupied: 1,
    rankRequired: 1
  },
  {
    id: 14,
    name: 'wooden_shield_orc',
    nameRu: 'Деревянный Щит Орка',
    weight: 4,
    attack: 0,
    activeDefense: 3,
    passiveDefense: 2,
    range: 0,
    actionPoints: 3,
    cellsOccupied: 1,
    rankRequired: 1
  },
  {
    id: 18,
    name: 'mutant_leather',
    nameRu: 'Кожа Мутанта',
    weight: 3,
    attack: 0,
    activeDefense: 0,
    passiveDefense: 2,
    range: 0,
    actionPoints: 0,
    cellsOccupied: 0,
    rankRequired: 1
  },
  // Ранг 2 (ветеран): каменная булава (12), каменный щит (15), костяные доспехи (19), томагавк (16), копьё (17)
  {
    id: 12,
    name: 'stone_mace',
    nameRu: 'Каменная Булава',
    weight: 6,
    attack: 6,
    activeDefense: 0,
    passiveDefense: 0,
    range: 1,
    actionPoints: 6,
    cellsOccupied: 1,
    rankRequired: 2
  },
  {
    id: 15,
    name: 'stone_shield',
    nameRu: 'Каменный Щит',
    weight: 5,
    attack: 0,
    activeDefense: 4,
    passiveDefense: 3,
    range: 0,
    actionPoints: 2,
    cellsOccupied: 1,
    rankRequired: 2
  },
  {
    id: 19,
    name: 'bone_armor',
    nameRu: 'Костяные Доспехи',
    weight: 4,
    attack: 0,
    activeDefense: 0,
    passiveDefense: 3,
    range: 0,
    actionPoints: 0,
    cellsOccupied: 0,
    rankRequired: 2
  },
  {
    id: 16,
    name: 'throwing_tomahawk',
    nameRu: 'Метательный Томагавк',
    weight: 3,
    attack: 3,
    activeDefense: 0,
    passiveDefense: 0,
    range: 3,
    actionPoints: 3,
    cellsOccupied: 2,
    rankRequired: 2
  },
  {
    id: 17,
    name: 'orc_spear',
    nameRu: 'Орочье Копьё',
    weight: 4,
    attack: 4,
    activeDefense: 0,
    passiveDefense: 1,
    range: 4,
    actionPoints: 4,
    cellsOccupied: 2,
    rankRequired: 2
  }
];

export function getWeaponById(id: number): Weapon | undefined {
  return WEAPONS.find(w => w.id === id);
}

export function canEquipTogether(weapon1: Weapon | null, weapon2: Weapon | null): boolean {
  if (!weapon1 || !weapon2) return true;
  
  // Проверяем, что общее количество занимаемых ячеек не превышает 2
  const totalCells = weapon1.cellsOccupied + weapon2.cellsOccupied;
  if (totalCells > 2) return false;
  
  // Если оба оружия - щиты, нельзя
  if (weapon1.attack === 0 && weapon2.attack === 0) return false;
  
  return true;
}

